import { post } from './requests'

export function transferOwnerships ({ owner, password }) {
  return post(`accounts/transfer_ownerships`, { user: { owner: owner, password: password } })
}
